export default __webpack_public_path__ + "static/luca-martinetti-5f7103bb4d8dee2f2a2dccba59746eba.png";